// extracted by mini-css-extract-plugin
export default {"createAccountPage":"ValidationSuccess_createAccountPage__-ls1z","spinnerHolder":"ValidationSuccess_spinnerHolder__QxpEm","formHolder":"ValidationSuccess_formHolder__N15uk"};